import styled from '@emotion/styled'
import * as mixins from 'view/styles/mixins'
import * as constants from 'view/styles/constants'

interface StatusContainerProps {
  awaiting: boolean
}

export const Container = styled.div`
  ${mixins.flexCenterContentCrossAxis};
  width: 100%;
  height: 100%;
  padding: 0 10px;
`
export const CheckboxContainer = styled.div`
  ${mixins.flexCenterContentCrossAxis};
  height: 100%;
`

export const StatusTimerContainer = styled.div`
  div {
    padding: 0 0 0 9px;
  }
`
export const StatusContainer = styled.div<StatusContainerProps>`
  font-weight: ${constants.FontWeight.Bold};

  svg {
    color: ${constants.CORE_PRIMARY_5};
    vertical-align: middle;
  }
`
